import { useNavigate, useParams } from "@tanstack/react-router";
import { useActiveBusiness } from "@teamna/web-client/hooks/use-owner.ts";
import { WriteLock } from "../components/WriteLock.tsx";
import { TakeAttendanceScreen } from "../attendance/take-attendance-screen.tsx";

/**
 * `/owner/schedule/:sessionId/attendance`: the owner or an admin takes attendance for any session,
 * with the same cards or list the staff use. Opened from the session panel on the Calendar.
 *
 * Open in read-only Desk: staff may take attendance, so an owner who runs the session may too.
 */
export function OwnerTakeAttendanceScreen() {
  const navigate = useNavigate();
  const { sessionId } = useParams({ strict: false }) as { sessionId: string };
  const { business, isLoading } = useActiveBusiness();
  return (
    <WriteLock reason={null}>
      <TakeAttendanceScreen
        business={business}
        businessLoading={isLoading}
        sessionId={sessionId}
        exitLabel="Calendar"
        fillScreen={false}
        onExit={() => void navigate({ to: "/owner/schedule" })}
      />
    </WriteLock>
  );
}
